<template>
  <div class="training-detail-bottom-bar">
    <template v-if="!isComplete">
      <ym-button class="training-submit-btn training-submit-btn-light secondary-btn"
                 @click="handleShowTrainingDetail"
      >
        简介
      </ym-button>
      <ym-button class="training-submit-btn training-submit-btn-primary primary-btn"
                 size="large"
                 :disabled="levelDetailBtn.disabled"
                 @click="handleShowLevelDetail"
      >
        {{ levelDetailBtn.text }}
      </ym-button>
    </template>
    <template v-else>
      <ym-button class="training-submit-btn training-submit-btn-light secondary-btn js-share-btn"
                 @click="handleClickShare"
      >
        分享
      </ym-button>
      <ym-button class="training-submit-btn primary-btn"
                 size="large"
                 :disabled="disabledCertificateBtn"
                 :class="`training-submit-btn-${certificateBtn.type}`"
                 @click="handleShowCertificate"
      >
        {{ certificateBtn.text }}
      </ym-button>
    </template>
    <share-mask :show.sync="showShareMask"
                :share-path="sharePath"
                message="请复制下方链接，前往粘贴给好友"
    />
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import ClipboardJS from 'clipboard';
  import { receiveCertificate } from '@/services/training';
  import ShareMask from '@/components/ShareMask';
  import validator from '@/utils/validator';
  import { isAppWebView, isWeiXinBrowser } from '@/utils';
  import { locationToAppWithRoute } from '@/utils/app-route';

  export default {
    name: 'TrainingDetailJoinedBottomBar',
    components: {
      'ym-button': Button,
      ShareMask,
    },
    data() {
      return {
        disabledShowLevelBtn: false,
        disabledCertificateBtn: false,
        showShareMask: false,
      };
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      isComplete: {
        type: Boolean,
        required: true,
      },
      isReceiveCertificate: {
        type: Boolean,
        required: true,
      },
      todoItem: {
        required: true,
        validator(val) {
          return validator.isObject(val);
        },
      },
      sharePath: {
        type: String,
      },
    },
    computed: {
      certificateBtn() {
        return this.isReceiveCertificate
          ? { type: 'primary', text: '查看证书' }
          : { type: 'highlight', text: '领取证书' };
      },
      levelDetailBtn() {
        if (!this.todoItem) {
          return { disabled: true, text: '未开始打卡' };
        }
        if (this.todoItem.status === 'finished') {
          return { disabled: true, text: '已打卡' };
        }
        if (this.todoItem.type === 'today') {
          return { disabled: false, text: '今日打卡' };
        }
        return { disabled: false, text: '补打卡' };
      },
    },
    methods: {
      handleShowTrainingDetail() {
        this.$emit('show-detail');
      },
      handleShowLevelDetail() {
        if (this.todoItem.status === 'finished') return;
        const route = { name: 'TrainingLevelDetail', params: { id: this.todoItem.id } };
        this.$router.push(route);
      },
      handleClickShare() {
        if (isWeiXinBrowser()) {
          this.showShareMask = true;
          return;
        }
        if (isAppWebView()) {
          const wechatShare = this.$wechat.getWechatMenuShareAppParams();
          locationToAppWithRoute({
            name: 'AppBaseShare',
            params: { ...wechatShare },
          }, 1);
          return;
        }
        const clipboard = new ClipboardJS('.js-share-btn');
        clipboard.on('success', () => {
          this.showShareMask = true;
        });
      },
      showCertificate() {
        const route = { name: 'TrainingCertificate', params: { id: this.id } };
        this.$router.push(route);
        this.disabledCertificateBtn = false;
      },
      async getCertification() {
        await receiveCertificate(this.id);
        this.showCertificate();
      },
      handleShowCertificate() {
        this.disabledCertificateBtn = true;
        if (!this.isReceiveCertificate) {
          this.getCertification();
          return;
        }
        this.showCertificate();
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-detail-bottom-bar {
    flex: 1;
    padding: @size-base;
    display: flex;
    justify-content: space-between;
    background-color: @color-white;
  }

  .secondary-btn {
    flex-shrink: 0;
    width: 234px;
    margin-right: @size-base;
    border: none;
  }

  .primary-btn {
    flex: 1;
  }
</style>
